export default "{\n    \"close\": \"Cerrar\"\n}\n"